export function randomId() {
  return (Date.now() * (1 + Math.random()) * (1 + Math.random())).toString();
}
